import * as tslib_1 from "tslib";
// Third party components
import { FieldWrapper } from "@ngx-formly/core";
// Custom components
/**
 * Script start
 */
var HorizontalWrapperComponent = /** @class */ (function (_super) {
    tslib_1.__extends(HorizontalWrapperComponent, _super);
    function HorizontalWrapperComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HorizontalWrapperComponent;
}(FieldWrapper));
export { HorizontalWrapperComponent };
